import ReferralsHeroSection from "./Components/ReferralsHeroSection";

export function Referrals() {
  return (
    <>
      <ReferralsHeroSection />
    </>
  );
}
